const DescriptionElement = (props) => {
  const { children, size = '' } = props;
  return <p className={`fbc-description ${size}`}>{children}</p>;
};

export default DescriptionElement;
